import React, { ReactElement, Suspense, useRef } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { useSelector } from 'react-redux';
import PrivateRoutes from './PrivateRoutes';
import { RootState } from '../../store';
import Main from '../../layout/Main';
import PublicRoutes from './PublicRoutes';
import Spinner from '../../shared/components/Spinner';
import RouteGuardHandler from '../../utils/appLevelUtility/RouteGuardHandler';
import { handleConfirmation } from '../../utils/utility';
import {useHistory} from 'react-router';
import { DeeplinkHandler } from './DeeplinkHandler';

const RouteLoader = (): ReactElement | null => {
  const routeGuardRef = useRef<any>();

  const isAuthenticated = useSelector(({ auth }: RootState): boolean => {
    return !!auth.token;
  });

  const history = useHistory();
  const isJitsi = history.location.pathname.includes('jitsi');

  return (
    <React.Fragment>
      <Router basename="/"
        getUserConfirmation={
          (messageText: string, callback: any): void =>
            handleConfirmation(messageText, callback, routeGuardRef)
        }>
        <DeeplinkHandler />
        <Suspense fallback={<Spinner />}>
          {isAuthenticated ? isJitsi ? <PrivateRoutes /> : (
            <Main>
              <PrivateRoutes />
            </Main>
          ) : <PublicRoutes />
          }
        </Suspense>
        <RouteGuardHandler ref={routeGuardRef} />
      </Router>
    </React.Fragment>
  );
};

export default RouteLoader;
